import { Component } from '@angular/core';

@Component({
  selector: 'app-permanent-management-fee-discount-decision-granting-request',
  templateUrl:
    './permanent-management-fee-discount-decision-granting-request.component.html',
  standalone: false,
})
export class PermanentManagementFeeDiscountDecisionGrantingRequestComponent {}
